import {useEffect, useState} from "react";
import { useSnackbar } from 'notistack';
import {useDeleteBranchMutation} from "../../../services/authService";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import styles from "../showName/DeleteShowName.module.scss";
import messages from "../../../utils/messages";
import ConfirmDialog from "../../ConfirmDialog";

const DeleteBranch = ({ branch, setBranch, onDelete }) => {
    const [deleteBranch, { isSuccess, error, reset }] = useDeleteBranchMutation();
    const { enqueueSnackbar } = useSnackbar();

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        deleteBranch(branch.id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(`${messages.success.deleteBranch}`, { variant: 'success' });
            reset();
            onDelete();
            setBranch(null);
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);


    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <ConfirmDialog
                title="Delete Branch"
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                {messages.confirm.deleteBranch}
            </ConfirmDialog>
        </>
    )
}

export default DeleteBranch;
